import React, { useState, Fragment, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from "@mui/material";
import * as constants from "../../../utils/Constants";

const AddMasterData = () => {
  let { state } = useLocation();
  let history = useHistory();
  if (!state) {
    state = {
      companyName: "",
      industriesName: "",
      states: "",
      cityName: "",
      stateName: "",
      stateCode: "",
      preferredCandidateLocationName: "",
    };
  }
  const [loginData, setLoginData] = useState({});
  const [cNameSpin, setcNameSpin] = useState(false);
  const [indSpin, setIndSpin] = useState(false);
  const [stateSpin, setStateSpin] = useState(false);
  const [citySpin, setCitySpin] = useState(false);
  const [cLocSpin, setcLocSpin] = useState(false);
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const [states, setStates] = useState([]);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   fetch(constants.ListStatesUrl, {
  //     headers: {
  //       Authorization: `Bearer ${loggedInUser.sessionToken}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       setStates(result);
  //     });
  // }, []);

  // .....
  const [input, setInput] = useState({
    companyName: "",
    industriesName: "",
    states: "",
    cityName: "",
    stateName: "",
    stateCode: "",
    preferredCandidateLocationName: "",
  });
  const [error, setError] = useState({
    companyName: "",
    industriesName: "",
    states: "",
    cityName: "",
    stateName: "",
    stateCode: "",
    preferredCandidateLocationName: "",
  });
  const onInputChange = (e) => {
    const { name, value } = e.target;
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateInput(e);
  };
  const validateInput = (e) => {
    let { name, value } = e.target;
    setError((prev) => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        // case "companyName":
        //   if (!value) {
        //     stateObj[name] = "Please Enter Company Name.";
        //   }
        //   break;
        case "industriesName":
          if (!value) {
            stateObj[name] = "Please Enter Industries Name.";
          }
          break;
        case "stateName":
          if (!value) {
            stateObj[name] = "Please Enter state Name.";
          }
          if (value) {
            stateObj[name] = [/[a-zA-Z]+/].every((pattern) =>
              pattern.test(value)

            ) || "Invalid State Name"
          }
          break;
        case "stateCode":
          if (!value) {
            stateObj[name] = "Please Enter state Code.";
          }
          break;
        case "cityName":
          if (!value) {
            stateObj[name] = "Please Enter city Name.";
          }
          break;
        case "preferredCandidateLocationName":
          if (!value) {
            stateObj[name] = "Please Enter Preferred Location.";
          }
          break;
        default:
          break;
      }
      return stateObj;
    });
  };

  // .....

  const handleBlur = (e) => {
    if (e.target.value == "") {
      setError((prev) => ({
        ...prev,
        ["states"]: "Please Select State",
      }));
    } else {
      setError((prev) => ({
        ...prev,
        ["states"]: "",
      }));
    }
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
  };

  // const submitCompanyName = () => {
  //   if (loginData.hasOwnProperty('companyName')) {
  //     setcNameSpin(true)
  //     document.getElementById('companyN').value = ""
  //     var url = `${constants.CompanyNameAddUrl}`;
  //     fetch(url, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${loggedInUser.sessionToken}`,
  //       },
  //       body: JSON.stringify(loginData),
  //     })
  //       .then((response) => response.json())
  //       .then((res) => {
  //         if (res.message) {
  //           toast.success(`✅ ${res.message.messageDescription} !`, {
  //             position: "top-right",
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //           });
  //           setTimeout(() => {
  //             setcNameSpin(false)
  //             setLoginData({})
  //           }, 3000);

  //         }
  //         else if (res.error) {
  //           toast.error(`❌ ${res.error.errorMessage} !`, {
  //             position: "top-right",
  //             autoClose: 3000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //           });
  //           setTimeout(() => {
  //             setcNameSpin(false)
  //             setLoginData({})
  //           }, 3000);
  //         }
  //       });
  //   }
  // };

  const submitIndustries = () => {
    if (loginData.hasOwnProperty('industriesName')) {
      setIndSpin(true)
      document.getElementById('industryN').value = ""
      var url = `${constants.IndustriesAddUrl}`;
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(loginData),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.message) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIndSpin(false)
              setLoginData({})
            }, 3000);
          }
          else if (res.error) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIndSpin(false)
              setLoginData({})
            }, 3000);
          }
        });
    }
  };
  const submitStates = () => {
    if (loginData.hasOwnProperty('stateCode')) {
      setStateSpin(true)
      document.getElementById('stateN').value = ""
      document.getElementById('stateC').value = ""
      var url = `${constants.StatesAddUrl}`;
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(loginData),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.message) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setStateSpin(false)
              setLoginData({})
            }, 3000);
          }
          else if (res.error) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setStateSpin(false)
              setLoginData({})
            }, 3000);
          }
        });
    }
  };
  const submitCity = () => {
    if (loginData.hasOwnProperty('cityName')) {
      setCitySpin(true)
      document.getElementById('selectS').value = ""
      document.getElementById('cityNa').value = ""
      var url = `${constants.CityAddUrl}`;
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify({
          "cityName": loginData.cityName,
          "state": { "stateId": loginData?.state }
        }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.message) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setCitySpin(false)
              setLoginData({})
            }, 3000);
          }
          else if (res.error) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setCitySpin(false)
              setLoginData({})
            }, 3000);
          }
        });
    }
  };
  const submitPreferredLocation = () => {
    if (loginData.hasOwnProperty('preferredCandidateLocationName')) {
      setcLocSpin(true)
      document.getElementById('pCL').value = ""
      var url = `${constants.PreferredLocationAddUrl}`;
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(loginData),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.message) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setcLocSpin(false)
              setLoginData({})
            }, 3000);
          }
          else if (res.error) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setcLocSpin(false)
              setLoginData({})
            }, 3000);
          }
        });
    }
  };
  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <div className="row">
            <div className="col-xl-12 col-lg-6">
              <div className="card flex-lg-column flex-md-row ">
                <div className="card-body card-body  text-center border-bottom profile-bx">
                  <form action="" method="post">
                    {/* <div className="form-group row">
                      <label className="col-lg-4 col-sm-4 col-xs-4 col-form-label Description-Label textAlign-Right">
                        Company Name :<span className="text-danger"></span>
                      </label>
                      <div className="col-lg-4 col-sm-4 col-xs-4">
                        <input
                          type="text"
                          id="companyN"
                          placeholder="Company Name"
                          defaultValue={state.companyName}
                          name="companyName"
                          onChange={onInputChange}
                          onBlur={validateInput}
                          className={
                            error.companyName.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                        ></input>
                        {error.companyName && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err "
                          >
                            {error.companyName}
                          </span>
                        )}
                      </div>
                      <div>
                        {
                          cNameSpin ?
                            <button style={{ border: 'none', backgroundColor: '#00ADEE' }}
                              type="button"
                              className="btn btn-primary btn-md">
                              <CircularProgress
                                color='inherit' size={20}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <button
                              className="btn btn-primary btn-md"
                              style={{ backgroundColor: "#00ADEE", border: "none" }}
                              type="button"
                              onClick={submitCompanyName}
                            >
                              <i
                                class="fa fa-plus-circle"
                                style={{ fontSize: "20px", textAlign: "center" }}
                              />
                            </button>
                        }
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="col-lg-4 col-sm-4 col-xs-4 col-form-label Description-Label textAlign-Right">
                        Industries :<span className="text-danger"></span>
                      </label>
                      <div className="col-lg-4 col-sm-4 col-xs-4">
                        <input
                          type="text"
                          id="industryN"
                          placeholder="Industries"
                          defaultValue={state.industriesName}
                          name="industriesName"
                          onChange={onInputChange}
                          onBlur={validateInput}
                          className={
                            error.industriesName.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                        ></input>
                        {error.industriesName && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.industriesName}
                          </span>
                        )}
                      </div>
                      <div>
                        {
                          indSpin ?
                            <button style={{ border: 'none', backgroundColor: '#00ADEE' }}
                              type="button"
                              className="btn btn-primary btn-md">
                              <CircularProgress
                                color='inherit' size={20}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <button
                              className="btn btn-primary btn-md"
                              style={{ backgroundColor: "#00ADEE", border: "none" }}
                              type="button"
                              onClick={submitIndustries}
                            >
                              <i
                                class="fa fa-plus-circle"
                                style={{ fontSize: "20px", textAlign: "center" }}
                              />
                            </button>
                        }
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label className="col-lg-4 col-sm-4 col-xs-4 col-form-label Description-Label textAlign-Right">
                        state :<span className="text-danger"></span>
                      </label>
                      <div className="col-lg-2 col-sm-2 col-xs-2">
                        <input
                          id="stateN"
                          type="text"
                          placeholder="state Name"
                          defaultValue={state.stateName}
                          pattern="[A-Za-z]{3}"
                          name="stateName"
                          onChange={onInputChange}
                          onBlur={validateInput}
                          className={
                            error.stateName.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                        ></input>
                        {error.stateName && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.stateName}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-2 col-sm-2 col-xs-2">
                        <input
                          id="stateC"
                          type="number"
                          placeholder="state Code"
                          defaultValue={state.stateCode}
                          name="stateCode"
                          onChange={onInputChange}
                          onBlur={validateInput}
                          className={
                            error.stateCode.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                        ></input>
                        {error.stateCode && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.stateCode}
                          </span>
                        )}
                      </div>
                      <div>
                        {
                          stateSpin ?
                            <button style={{ border: 'none', backgroundColor: '#00ADEE' }}
                              type="button"
                              className="btn btn-primary btn-md">
                              <CircularProgress
                                color='inherit' size={20}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <button
                              className="btn btn-primary btn-md"
                              style={{ backgroundColor: "#00ADEE", border: "none" }}
                              type="button"
                              onClick={submitStates}
                            >
                              <i
                                class="fa fa-plus-circle"
                                style={{ fontSize: "20px", textAlign: "center" }}
                              />
                            </button>
                        }
                      </div>
                    </div> */}

                    {/* <div className="form-group row" id="">
                      <label className="col-lg-4 col-sm-4 col-xs-4 col-form-label Description-Label textAlign-Right ">
                        City :<span className="text-danger"></span>
                      </label>
                      <div className="col-lg-2 col-sm-2 col-xs-2">
                        <select
                          id="selectS"
                          name="state"
                          onChange={handleBlur}
                          className={
                            error.states.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                        >
                          <option value="">Select State</option>
                          {states?.map((states) => (
                            <option
                              selected={
                                state?.state == states?.stateName
                                  ? "selected"
                                  : ""
                              }
                              value={states?.stateId}
                            >
                              {states?.stateName}
                            </option>
                          ))}
                        </select>
                        {error.states && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.states}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-2 col-sm-2 col-xs-2">
                        <input
                          id="cityNa"
                          type="text"
                          placeholder="cityName"
                          onChange={onInputChange}
                          onBlur={validateInput}
                          className={
                            error.cityName.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                          defaultValue={state.cityName}
                          name="cityName"
                        ></input>
                        {error.cityName && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.cityName}
                          </span>
                        )}
                      </div>
                      <div>
                        {
                          citySpin ?
                            <button style={{ border: 'none', backgroundColor: '#00ADEE' }}
                              type="button"
                              className="btn btn-primary btn-md">
                              <CircularProgress
                                color='inherit' size={20}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <button
                              className="btn btn-primary btn-md"
                              style={{ backgroundColor: "#00ADEE", border: "none" }}
                              type="button"
                              onClick={submitCity}
                            >
                              <i
                                class="fa fa-plus-circle"
                                style={{ fontSize: "20px", textAlign: "center" }}
                              />
                            </button>
                        }
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="col-lg-4 col-sm-4 col-xs-4 col-form-label Description-Label textAlign-Right">
                        Preferred Candidate Location :
                        <span className="text-danger"></span>
                      </label>
                      <div className="col-lg-4 col-sm-4 col-xs-4">
                        <input
                          id="pCL"
                          type="text"
                          placeholder="Preferred Candidate Location"
                          defaultValue={state.preferredCandidateLocationName}
                          onChange={onInputChange}
                          onBlur={validateInput}
                          className={
                            error.preferredCandidateLocationName.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                          name="preferredCandidateLocationName"
                        ></input>
                        {error.preferredCandidateLocationName && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.preferredCandidateLocationName}
                          </span>
                        )}
                      </div>
                      <div>
                        {
                          cLocSpin ?
                            <button style={{ border: 'none', backgroundColor: '#00ADEE' }}
                              type="button"
                              className="btn btn-primary btn-md">
                              <CircularProgress
                                color='inherit' size={20}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <button
                              className="btn btn-primary btn-md "
                              style={{ backgroundColor: "#00ADEE", border: "none" }}
                              type="button"
                              onClick={submitPreferredLocation}
                            >
                              <i
                                class="fa fa-plus-circle"
                                style={{ fontSize: "20px", textAlign: "center" }}
                              />
                            </button>
                        }
                      </div>
                    </div>
                    <ToastContainer />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default AddMasterData;